import React, { useEffect, useState } from 'react';
import { getRelatorio, getFuncionariosResumo, getDepartamentos, exportarRelatorio } from '../services/api';

function primeiroDiaMes() {
  const d = new Date(); d.setDate(1);
  const dd = String(d.getDate()).padStart(2,'0'), mm = String(d.getMonth()+1).padStart(2,'0');
  return `${dd}/${mm}/${d.getFullYear()}`;
}
function hoje() {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2,'0'), mm = String(d.getMonth()+1).padStart(2,'0');
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export default function Relatorios() {
  const [filtros, setFiltros] = useState({ data_inicio: primeiroDiaMes(), data_fim: hoje(), funcionario: '', departamento: '' });
  const [resultado, setResultado] = useState(null);
  const [funcionarios, setFuncionarios] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [aba, setAba] = useState('detalhado');

  useEffect(() => {
    getFuncionariosResumo().then(r => setFuncionarios(r.data));
    getDepartamentos({ ativo: true }).then(r => setDepartamentos(r.data.results || r.data));
  }, []);

  const gerar = async () => {
    setLoading(true);
    try { const r = await getRelatorio(filtros); setResultado(r.data); }
    finally { setLoading(false); }
  };

  const totais = resultado?.resumo?.reduce((acc, r) => ({
    total_dias:   acc.total_dias + r.total_dias,
    total_horas:  acc.total_horas + r.total_horas,
    total_extras: acc.total_extras + r.total_extras,
    faltas:       acc.faltas + r.faltas,
  }), { total_dias: 0, total_horas: 0, total_extras: 0, faltas: 0 });

  const STATS = resultado ? [
    { label: 'Registros',    value: resultado.total_registros,           grad: 'linear-gradient(135deg,#4f46e5,#6366f1)' },
    { label: 'Dias trab.',   value: totais?.total_dias,                  grad: 'linear-gradient(135deg,#0891b2,#06b6d4)' },
    { label: 'Total Horas',  value: `${totais?.total_horas?.toFixed(1)}h`, grad: 'linear-gradient(135deg,#059669,#10b981)' },
    { label: 'Horas Extras', value: `${(totais?.total_extras||0).toFixed(1)}h`, grad: totais?.total_extras > 0 ? 'linear-gradient(135deg,#d97706,#f59e0b)' : 'linear-gradient(135deg,#64748b,#94a3b8)' },
    { label: 'Faltas',       value: totais?.faltas,                      grad: 'linear-gradient(135deg,#dc2626,#ef4444)' },
  ] : [];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 16, marginBottom: 20, borderBottom: '1px solid #f1f5f9' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 38, height: 38, background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary)', fontSize: '1rem', marginRight: 14, flexShrink: 0 }}>
            <i className="bi bi-bar-chart-line-fill" />
          </div>
          <div>
            <div style={{ fontSize: '0.62rem', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 3 }}>Gestão de Pessoal · Controle de Ponto</div>
            <div style={{ fontSize: '1.3rem', fontWeight: 700, color: '#334155', letterSpacing: '-0.5px', lineHeight: 1.2 }}>Relatórios</div>
          </div>
        </div>
        {resultado && (
          <button style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 6, padding: '3px 9px', cursor: 'pointer', color: '#15803d', fontSize: '0.72rem', fontWeight: 600 }} onClick={() => exportarRelatorio(filtros)}>
            <i className="bi bi-file-earmark-excel"></i>Exportar Excel
          </button>
        )}
      </div>

      {/* Filtros */}
      <div className="filter-bar mb-4">
        <div style={{ minWidth: 140 }}>
          <label className="form-label">Data início</label>
          <input className="form-control" placeholder="DD/MM/AAAA" value={filtros.data_inicio} onChange={e => setFiltros({ ...filtros, data_inicio: e.target.value })} />
        </div>
        <div style={{ minWidth: 140 }}>
          <label className="form-label">Data fim</label>
          <input className="form-control" placeholder="DD/MM/AAAA" value={filtros.data_fim} onChange={e => setFiltros({ ...filtros, data_fim: e.target.value })} />
        </div>
        <div style={{ flex: 2, minWidth: 180 }}>
          <label className="form-label">Funcionário</label>
          <select className="form-select" value={filtros.funcionario} onChange={e => setFiltros({ ...filtros, funcionario: e.target.value })}>
            <option value="">Todos</option>
            {funcionarios.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
          </select>
        </div>
        <div style={{ flex: 1, minWidth: 160 }}>
          <label className="form-label">Departamento</label>
          <select className="form-select" value={filtros.departamento} onChange={e => setFiltros({ ...filtros, departamento: e.target.value })}>
            <option value="">Todos</option>
            {departamentos.map(d => <option key={d.id} value={d.id}>{d.nome}</option>)}
          </select>
        </div>
        <div style={{ alignSelf: 'flex-end' }}>
          <button className="btn-primary-custom" style={{ padding: '10px 22px' }} onClick={gerar} disabled={loading}>
            {loading ? <span className="spinner-border spinner-border-sm" /> : <><i className="bi bi-search me-1" />Gerar</>}
          </button>
        </div>
      </div>

      {/* Stats */}
      {resultado && (
        <div className="row g-3 mb-4">
          {STATS.map((s, i) => (
            <div key={i} className="col">
              <div className="card-stat" style={{ background: s.grad }}>
                <p>{s.label}</p>
                <h3>{s.value}</h3>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Tabelas */}
      {resultado && (
        <div className="card-ponto">
          <div style={{ padding: '16px 20px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid var(--border)', paddingBottom: 0 }}>
            <div className="tabs-custom mb-0" style={{ marginBottom: 0 }}>
              {[['detalhado','Detalhado'], ['resumo','Resumo por Funcionário']].map(([k, l]) => (
                <button key={k} className={`tab-btn ${aba === k ? 'active' : ''}`} onClick={() => setAba(k)}>{l}</button>
              ))}
            </div>
            <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)', paddingBottom: 8 }}>
              {resultado.total_registros} registro(s)
            </span>
          </div>

          <div style={{ padding: '8px 0' }}>
            {aba === 'detalhado' && (
              <div className="table-responsive">
                <table className="table table-ponto mb-0">
                  <thead>
                    <tr>
                      <th style={{ paddingLeft: 32 }}>Funcionário</th><th>Depto</th><th>Data</th>
                      <th>Entrada</th><th>Saída</th><th>Horas</th>
                      <th>Extras</th><th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultado.registros.map(r => (
                      <tr key={r.id}>
                        <td style={{ paddingLeft: 32 }}>
                          <div style={{ fontWeight: 600, fontSize: '0.84rem' }}>{r.funcionario}</div>
                          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>#{r.matricula}</div>
                        </td>
                        <td style={{ fontSize: '0.8rem' }}>{r.departamento || '—'}</td>
                        <td style={{ fontSize: '0.82rem' }}>{r.data}</td>
                        <td style={{ fontWeight: 600 }}>{r.hora_entrada || '—'}</td>
                        <td style={{ fontWeight: 600 }}>{r.hora_saida || '—'}</td>
                        <td><span style={{ color: 'var(--primary)', fontWeight: 700 }}>{r.horas_trabalhadas ? `${r.horas_trabalhadas}h` : '—'}</span></td>
                        <td>
                          {r.horas_extras !== 0
                            ? <span style={{ background: r.horas_extras > 0 ? '#fef3c7' : '#fee2e2', color: r.horas_extras > 0 ? '#92400e' : '#991b1b', borderRadius: 20, padding: '2px 8px', fontSize: '0.72rem', fontWeight: 700 }}>
                                {r.horas_extras > 0 ? '+' : ''}{r.horas_extras}h
                              </span>
                            : '—'}
                        </td>
                        <td><span className={`badge-status badge-status-${r.status}`}>{r.status_display}</span></td>
                      </tr>
                    ))}
                    {resultado.registros.length === 0 && (
                      <tr><td colSpan={8}><div className="empty-state"><i className="bi bi-inbox" /><p>Nenhum registro no período</p></div></td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {aba === 'resumo' && (
              <div className="table-responsive">
                <table className="table table-ponto mb-0">
                  <thead>
                    <tr>
                      <th style={{ paddingLeft: 32 }}>Funcionário</th><th>Dias</th>
                      <th>Total Horas</th><th>Horas Extras</th>
                      <th>Faltas</th><th>Atestados</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultado.resumo.map((r, i) => (
                      <tr key={i}>
                        <td style={{ paddingLeft: 32 }}>
                          <div style={{ fontWeight: 600, fontSize: '0.84rem' }}>{r.funcionario}</div>
                          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>#{r.matricula}</div>
                        </td>
                        <td style={{ fontWeight: 600 }}>{r.total_dias}</td>
                        <td><span style={{ color: 'var(--primary)', fontWeight: 700 }}>{r.total_horas.toFixed(1)}h</span></td>
                        <td>
                          {r.total_extras !== 0
                            ? <span style={{ background: r.total_extras > 0 ? '#fef3c7' : '#fee2e2', color: r.total_extras > 0 ? '#92400e' : '#991b1b', borderRadius: 20, padding: '2px 10px', fontSize: '0.72rem', fontWeight: 700 }}>
                                {r.total_extras > 0 ? '+' : ''}{r.total_extras.toFixed(1)}h
                              </span>
                            : '—'}
                        </td>
                        <td>{r.faltas > 0 ? <span style={{ background: '#fee2e2', color: '#991b1b', borderRadius: 20, padding: '2px 10px', fontSize: '0.72rem', fontWeight: 700 }}>{r.faltas}</span> : '—'}</td>
                        <td>{r.atestados > 0 ? <span style={{ background: '#fef3c7', color: '#92400e', borderRadius: 20, padding: '2px 10px', fontSize: '0.72rem', fontWeight: 700 }}>{r.atestados}</span> : '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {!resultado && !loading && (
        <div className="card-ponto" style={{ padding: '64px 20px' }}>
          <div className="empty-state">
            <i className="bi bi-bar-chart-line" style={{ fontSize: '3rem', opacity: 0.15, color: 'var(--primary)' }}></i>
            <p style={{ fontWeight: 600, fontSize: '0.95rem', marginTop: 8 }}>Configure os filtros e clique em <strong>Gerar</strong></p>
            <p style={{ fontSize: '0.82rem' }}>O relatório aparecerá aqui</p>
          </div>
        </div>
      )}
    </div>
  );
}
